import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let payment_id = useDataValue({
    context: 'entry',
    path: 'transaction.applied_payment.payment.id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'entry',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'FOCUS_PAYMENT', payment_id })
  }
}
